import React from 'react';
import logoUrl from "../../images/RBIS-Logo-New.png";
// 1. Import Link from react-router-dom as 'RouterLink' to avoid naming conflicts
import { Link as RouterLink } from 'react-router-dom'; 
import { AppBar, Toolbar, Box } from '@mui/material'; // Removed 'Link' from here as we don't need the MUI styled link

const Newheader = () => {
  return (
    <div>
      <AppBar
        position="static"
        elevation={1} 
        sx={{
          backgroundColor: '#ffffff', 
          borderBottom: '1px solid #e0e0e0', 
        }}
      >
        <Toolbar
          sx={{
            justifyContent: 'space-between', 
            padding: '0 40px', 
          }}
        >
          {/* Logo */}
          {/* 2. Change 'component={Link}' to 'component={RouterLink}' */}
          <Box
            component={RouterLink} 
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              cursor: 'pointer' // Good practice to add cursor pointer
            }}
          >
            <Box
              component="img"
              src={logoUrl} 
              alt="Avery Dennison Logo"
              sx={{
                height: 90, 
                width: 'auto',
                py: 3,
              }}
            />
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Newheader;